/** The number a code was just sent to — in memory only, never the URL or storage. A reload starts over. */
let pending: string | null = null;
/** Where the person was when their session ended (spec 3A §6.2). Memory only; only ever a path inside the app. */
let place: string | null = null;
/** A session ended while in use: not a first visit, not a deliberate logout (spec 3A §9). */
let ended = false;

export const loginFlow = {
  get: () => pending,
  set: (phone: string | null) => {
    pending = phone;
  },
  rememberPlace: (href: string) => {
    place = href.startsWith('/') && !href.startsWith('//') && !href.startsWith('/login') ? href : null;
  },
  /** Where to go after logging in, once: the remembered place, else Home. */
  takePlace: (): string => {
    const to = place ?? '/';
    place = null;
    ended = false;
    return to;
  },
  markEnded: () => {
    ended = true;
  },
  /** The login screen says "Please log in again." */
  ended: () => ended,
  /** A fresh page (tests start one per render). */
  reset: () => {
    pending = null;
    place = null;
    ended = false;
  },
};
